__turbopack_context__.v({
  "className": "I5ZHZG_className",
  "variable": "I5ZHZG_variable",
});
